import { Component, Input } from "@angular/core";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-manage-files",
	templateUrl: "./manage-files.component.html",
	styleUrls: ["./manage-files.component.scss"]
})
export class ManageFilesComponent {
	@Input()
	asset: APIResults.Asset;
}
